module.exports = __webpack_public_path__ + "static/media/User.7a91fdb8.svg";